import {Component, OnInit, signal} from '@angular/core';
import {ExtraCostCountType, ExtraCostType} from '../../classes/extracosttype.class';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {ExtraCostsService} from '../../services/extraCosts/extra-costs.service';
import {Utils} from '../../utils.class';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatError, MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-extra-cost-detail',
    templateUrl: './extra-cost-detail.component.html',
    styleUrls: ['./extra-cost-detail.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        ReactiveFormsModule,
        RouterLink,
        MatFormField,
        MatInput,
        MatError,
        MatLabel,
        MatSelect,
        MatOption,
        MatCheckbox,
        MatButton
    ]
})
export class ExtraCostDetailComponent implements OnInit {

    readonly extraCostType = signal<ExtraCostType>(null);

    readonly form = signal<FormGroup>(new FormGroup({
        name: new FormControl('', [Validators.required, Validators.min(3), Validators.max(99)]),
        unit: new FormControl('', [Validators.required, Validators.min(1), Validators.max(99)]),
        count_based_on: new FormControl(null, [Validators.required]),
        night: new FormControl(false)
    }));

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private extraCostsService: ExtraCostsService
    ) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {

            this.extraCostsService.getList().then(extraCostTypes => {
                let found = null;
                extraCostTypes.forEach(extraCostType => {
                    if (extraCostType.id === +params['id']) {
                        found = extraCostType;
                    }
                });
                this.extraCostType.set(found || new ExtraCostType());

                Object.entries(this.form().controls).forEach(control => {
                    if (typeof this.extraCostType()[control[0]] !== 'undefined') {
                        this.form().controls[control[0]].setValue(this.extraCostType()[control[0]]);
                    }
                });
            });
        });
    }

    save() {
        Utils.triggerValidationP(this.form()).then(() => {
            Object.assign(this.extraCostType(), this.form().value);
            this.extraCostsService.saveType(this.extraCostType()).then(extraCostType => {
                this.router.navigate([`extra-costs`]);
            }, error => {

            });
        }, () => {

        });

    }

    readonly ExtraCostCountType = ExtraCostCountType;
}
